(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grounded-faq-page"] && !Shopify.designMode) return;
  try {
    
  if (!window.__groundedFaqGorgiasBound) {
    window.__groundedFaqGorgiasBound = true;

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-grounded-gorgias-form]');
      if (!form) return;

      event.preventDefault();

      var input = form.querySelector('input[name="question"]');
      var button = form.querySelector('button[type="submit"]');
      var status = form.parentElement.querySelector('[data-grounded-gorgias-status]');
      var question = input ? input.value.trim() : '';

      if (!question) return;

      if (button) button.disabled = true;
      if (status) status.textContent = '';

      var gorgiasReady = window.GorgiasChat
        ? window.GorgiasChat.init()
        : new Promise(function (resolve, reject) {
            var timeout = window.setTimeout(function () {
              reject(new Error('Gorgias chat did not load'));
            }, 8000);

            window.addEventListener(
              'gorgias-widget-loaded',
              function () {
                window.clearTimeout(timeout);
                resolve();
              },
              { once: true }
            );
          });

      gorgiasReady
        .then(function () {
          if (!window.GorgiasChat) throw new Error('Gorgias chat unavailable');

          var chat = window.GorgiasChat;
          var sendStarted = false;
          var confirmed = false;
          var fallbackTimer;

          var markSent = function () {
            confirmed = true;
            if (fallbackTimer) window.clearTimeout(fallbackTimer);
            if (input) input.value = '';
            if (status) status.textContent = '';
            if (button) button.disabled = false;
            if (chat.off) chat.off('message:sent', markSent);
          };

          var sendQuestion = function () {
            if (sendStarted) return;
            sendStarted = true;

            try {
              chat.setPage('chat');
              chat.setCurrentInput(question);

              window.setTimeout(function () {
                try {
                  chat.sendMessage(question);
                } catch (error) {
                  if (status) status.textContent = form.dataset.unavailable || '';
                  if (button) button.disabled = false;
                }
              }, 250);

              fallbackTimer = window.setTimeout(function () {
                if (confirmed) return;
                try {
                  chat.setPage('chat');
                  chat.setCurrentInput(question);
                } catch (error) {
                  return;
                }
                if (status) status.textContent = 'Your question is ready in chat \u2014 tap send.';
                if (button) button.disabled = false;
              }, 2200);
            } catch (error) {
              if (status) status.textContent = form.dataset.unavailable || '';
              if (button) button.disabled = false;
            }
          };

          if (chat.on) {
            chat.on('message:sent', markSent);
            chat.on('widget:opened', sendQuestion);
          }

          chat.setPage('chat');
          chat.open();

          window.setTimeout(function () {
            if (chat.isOpen && chat.isOpen()) sendQuestion();
          }, 120);

          window.setTimeout(sendQuestion, 700);
        })
        .catch(function () {
          if (status) status.textContent = form.dataset.unavailable || '';
          if (button) button.disabled = false;
        });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grounded-gorgias-ask"] && !Shopify.designMode) return;
  try {
    
  if (!window.__groundedFaqGorgiasBound) {
    window.__groundedFaqGorgiasBound = true;

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-grounded-gorgias-form]');
      if (!form) return;

      event.preventDefault();

      var input = form.querySelector('input[name="question"]');
      var button = form.querySelector('button[type="submit"]');
      var status = form.parentElement.querySelector('[data-grounded-gorgias-status]');
      var question = input ? input.value.trim() : '';

      if (!question) return;

      if (button) button.disabled = true;
      if (status) status.textContent = '';

      var gorgiasReady = window.GorgiasChat
        ? window.GorgiasChat.init()
        : new Promise(function (resolve, reject) {
            var timeout = window.setTimeout(function () {
              reject(new Error('Gorgias chat did not load'));
            }, 8000);

            window.addEventListener(
              'gorgias-widget-loaded',
              function () {
                window.clearTimeout(timeout);
                resolve();
              },
              { once: true }
            );
          });

      gorgiasReady
        .then(function () {
          if (!window.GorgiasChat) throw new Error('Gorgias chat unavailable');

          var chat = window.GorgiasChat;
          var sendStarted = false;
          var confirmed = false;
          var fallbackTimer;

          var markSent = function () {
            confirmed = true;
            if (fallbackTimer) window.clearTimeout(fallbackTimer);
            if (input) input.value = '';
            if (status) status.textContent = '';
            if (button) button.disabled = false;
            if (chat.off) chat.off('message:sent', markSent);
          };

          var sendQuestion = function () {
            if (sendStarted) return;
            sendStarted = true;

            try {
              chat.setPage('chat');
              chat.setCurrentInput(question);

              window.setTimeout(function () {
                try {
                  chat.sendMessage(question);
                } catch (error) {
                  if (status) status.textContent = form.dataset.unavailable || '';
                  if (button) button.disabled = false;
                }
              }, 250);

              fallbackTimer = window.setTimeout(function () {
                if (confirmed) return;
                try {
                  chat.setPage('chat');
                  chat.setCurrentInput(question);
                } catch (error) {
                  return;
                }
                if (status) status.textContent = 'Your question is ready in chat — tap send.';
                if (button) button.disabled = false;
              }, 2200);
            } catch (error) {
              if (status) status.textContent = form.dataset.unavailable || '';
              if (button) button.disabled = false;
            }
          };

          if (chat.on) {
            chat.on('message:sent', markSent);
            chat.on('widget:opened', sendQuestion);
          }

          chat.setPage('chat');
          chat.open();

          window.setTimeout(function () {
            if (chat.isOpen && chat.isOpen()) sendQuestion();
          }, 120);

          window.setTimeout(sendQuestion, 700);
        })
        .catch(function () {
          if (status) status.textContent = form.dataset.unavailable || '';
          if (button) button.disabled = false;
        });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grounded-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grounded-pdp-subscription"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('grounded-pdp-subscription')) {
    customElements.define('grounded-pdp-subscription', class extends HTMLElement {
      connectedCallback() {
        const select = this.querySelector('select[name="selling_plan"]');
        if (!select) return;
        select.addEventListener('change', () => {
          const option = select.selectedOptions[0];
          const price = this.querySelector('[data-subscription-price]');
          const regularPrice = this.querySelector('[data-regular-price]');
          const saving = this.querySelector('[data-subscription-saving]');
          if (price) price.textContent = option.dataset.price || '';
          if (regularPrice) regularPrice.textContent = option.dataset.regularPrice || '';
          if (saving) saving.textContent = option.dataset.saving || '';
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grounded-shipping-returns"] && !Shopify.designMode) return;
  try {
    
if (!window.groundedDeliveryChatBound) {
  window.groundedDeliveryChatBound = true;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-grounded-delivery-chat]');
    if (!button || button.disabled) return;
    var contact = button.closest('[data-grounded-delivery-contact]');
    var status = contact.querySelector('[data-grounded-delivery-status]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = button.dataset.loading;

    var settled = false;
    var initializing = false;
    var timeout;
    function finish(error) {
      if (settled) return;
      settled = true;
      window.clearTimeout(timeout);
      window.removeEventListener('gorgias-widget-loaded', initialize);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      status.textContent = error ? button.dataset.unavailable : '';
    }
    function initialize() {
      if (settled || initializing || !window.GorgiasChat) return;
      initializing = true;
      try {
        Promise.resolve(window.GorgiasChat.init()).then(function () {
          if (settled) return;
          try {
            window.GorgiasChat.setPage('conversation');
            window.GorgiasChat.open();
            finish();
          } catch (error) {
            finish(error);
          }
        }, finish);
      } catch (error) {
        finish(error);
      }
    }
    timeout = window.setTimeout(function () {
      finish(new Error('Chat unavailable'));
    }, 8000);
    window.addEventListener('gorgias-widget-loaded', initialize);
    initialize();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-subscription-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('grounded-pdp-subscription')) {
    customElements.define('grounded-pdp-subscription', class extends HTMLElement {
      connectedCallback() {
        const select = this.querySelector('select[name="selling_plan"]');
        if (!select) return;
        select.addEventListener('change', () => {
          const option = select.selectedOptions[0];
          const price = this.querySelector('[data-subscription-price]');
          const regularPrice = this.querySelector('[data-regular-price]');
          const saving = this.querySelector('[data-subscription-saving]');
          if (price) price.textContent = option.dataset.price || '';
          if (regularPrice) regularPrice.textContent = option.dataset.regularPrice || '';
          if (saving) saving.textContent = option.dataset.saving || '';
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
